import axios from 'axios'
import axiosConfig from 'utils/axiosConfig'

export const getExaminationList = (payload) => {
  return axiosConfig.post(`/examinations`, payload)
}

export const getExaminationDetails = async (id) => {
  let response = await axiosConfig.get(`examinations/${id}`)

  if (response.status !== 200) {
    console.log(response)
  }

  let responseBody = response.data
  if (!responseBody.success) {
    console.log(responseBody.message)
  }

  return responseBody.details
}

export const updateExamination = async (id, payload) => {
  let response = await axiosConfig.post(`examinations/${id}`, {...payload, _method: 'PATCH'})
}

export const getUserClassrooms = async (userId) => {
  let response = await axiosConfig.get(`/user-classrooms`)

  if (response.status !== 200) {
    console.log(response)
  }

  let responseBody = response.data
  if (!responseBody.success) {
    console.log(responseBody.message)
  }

  return responseBody.classrooms
}

export const uploadMedia = async (formData) => {
  let response = await axiosConfig.post(`examinations-image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
      console.log(percentCompleted)
    }
  })

  if (response.status !== 200) {
    console.log(response)
  }

  let responseBody = response.data
  if (!responseBody.success) {
    console.log(responseBody.message)
  }

  return responseBody.image
}

export const deleteMedia = async (id) => {
  let response = await axiosConfig.post(`examinations-image/delete`, {
    id
  })

  if (response.status !== 200) {
    console.log(response)
  }

  let responseBody = response.data
  if (!responseBody.success) {
    console.log(responseBody.message)
  }
}

export const saveQuestion = async (exam, question) => {
  const response = await axiosConfig.post(`/questions`, {
    exam: exam,
    description: question.description,
    options: question.options?.map((option) => {
      return {
        id: option.id,
        text: option.text,
        img: option.img_id
      }
    }),
    answer: question.answerKey,
    images: question.images,
    type: question.type,
    pts: question.pts
  })

  if (response.status !== 200) {
    console.log(response)
    return
  }

  return response.data
}

export const getExaminationQuestions = async (exam) => {
  const response = await axiosConfig.get(`/questions/${exam}`)

  if (response.status !== 200) {
    console.log(response)
    return
  }

  const responseBody = response.data
  if (!responseBody.success) {
    console.log(responseBody.message)
  }

  return responseBody.questions
}

export const submitDeleteQuestion = async (exam, question) => {
  const response = await axiosConfig.post(`/questions/${exam}/delete/${question}`)

  if (response.status !== 200) {
    console.log(response)
    return
  }

  const responseBody = response.data
  if (!responseBody.success) {
    console.log(responseBody.message)
    return
  }

  return true
}

export const updateQuestion = async (exam, questionId, question) => {
  const response = await axiosConfig.post(`/questions/${exam}/update/${questionId}`, {
    exam: exam,
    description: question.description,
    options: question.options?.map((option) => {
      return {
        id: option.id,
        text: option.text,
        img: option.img_id
      }
    }),
    answer: question.answerKey,
    images: question.images,
    type: question.type,
    pts: question.pts,
    bonus: question.bonus !== undefined
      ? question.bonus
      : false
  })

  return response.data
}

export const getFacultyList = async () => {
  const response = await axiosConfig.get(`/faculty`)

  return response.data.users
}